import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  topRight: {
    fontSize: 14,
    fontWeight: 500,
    textAlign: "right",
    [theme.breakpoints.down('md')]: {
      fontSize: 12,
    },
  },
  avatar: {
    height: 32,
    width: 32,
    fontSize: 14,
    fontWeight: 600,
    [theme.breakpoints.down('md')]: {
      height: 28,
      width: 28,
      fontSize: 12,
    },
  },
  link: {
    textDecoration: "none",
    width: 200,
    color: "#8D98C2",
    fontWeight: 500,
    [theme.breakpoints.down('md')]: {
      width: "100%",
    },
  },
  menu: {
    "& .MuiPaper-root": {
      left: "auto !important",
      right: 30,
      // Anchor directly under the 64px desktop top nav.
      top: "64px !important",
    },
    [theme.breakpoints.down('md')]: {
      // Mobile-only: tuck the Paper one level below the header (zIndex 100
      // — see AdminLayout.styles.ts) so the dropdown emerges from underneath
      // the nav rather than floating awkwardly below the rounded bottom
      // edge. The header's white surface covers the top 16px of the Paper,
      // so its rounded bottom corners visually "melt" into the menu while
      // it is open. Desktop keeps the default float-above behavior since
      // its header has no rounded bottom corners.
      zIndex: ("99 !important" as unknown) as number,
      "& .MuiPaper-root": {
        left: "0 !important",
        right: "0 !important",
        // Overlap the 80px mobile header by 16px — matches the header's
        // 16px rounded bottom-corner radius, so the header's curve sits
        // directly on top of the Paper's flat top edge and the two shapes
        // merge into one continuous surface while open. The hidden strip
        // is absorbed by `paddingTop` so no menu item is cropped.
        top: "64px !important",
        paddingTop: 16,
        width: "100%",
        maxWidth: "100% !important",
        borderRadius: 0,
        boxShadow: "0 8px 16px rgba(15, 23, 42, 0.08)",
      },
      "& .MuiList-root": {
        padding: 0,
      },
      "& .MuiMenuItem-root": {
        padding: "16px 20px",
        minHeight: 48,
        width: "100%",
      },
    },
    "& .MuiListItem-button:hover": {
      color: theme.palette.primary.main,
      backgroundColor: "#F7F9FF",
      "& .icon": {
        stroke: theme.palette.primary.main,
      },
      "& .personalIcon": {
        fill: theme.palette.primary.main,
      },
    },
    "& .MuiSvgIcon-root": {
      verticalAlign: "bottom",
    },
    "& svg": {
      verticalAlign: "bottom",
    },
    "& .personalIcon": {
      verticalAlign: "middle",
    },
  },
  iconWrapper: {
    width: 35,
    display: "inline-block",
  },
  linkWrapper: {
    width: 35,
    display: "inline-block",
    paddingLeft: 3,
    verticalAlign: "text-bottom",
  },
  menuBtn: {
    // Hug the avatar — vertical padding preserves a 48px tap target
    // (Material guidelines) while horizontal padding is 0 so the avatar
    // sits flush with the right edge of the top-nav cluster.
    minWidth: 0,
    minHeight: 48,
    padding: "8px 0",
    [theme.breakpoints.down('md')]: {
      fontSize: 12,
      minWidth: 0,
      minHeight: 48,
      padding: "8px 0",
    },
  },
}));
